import { DEFAULT_BUTTON_SIZE } from '../../../../../store/reducers/ui';
import { TOOLTIP_BACKGROUND_PADDING } from '../../../../common/components/tooltips/styles';
import { FTV_TIMING_FUNCTION_IN, MODAL_LAYER } from '../../../theme/constants';

export const MODAL_CONTAINER_STYLES = {
  default: {
    lineHeight: '21px',
    fontSize: 16,
    width: '480px',
    bottom: 'calc(100% + 8px)',
    padding: 0,
    maxWidth: 500,
    borderRadius: 20,
    position: 'absolute',
    marginRight: 'initial',
    transition: `all .25s ${FTV_TIMING_FUNCTION_IN}`,
    zIndex: MODAL_LAYER,
    pointerEvents: 'auto',
    transitionProperty: 'max-width, width, opacity',
    transitionDuration: '.25s',
    transitionTimingFunction: FTV_TIMING_FUNCTION_IN,
    boxShadow: '0px 6px 14px -2px rgba(0, 0, 0, 0.45)',
    display: 'flex'
  },
  'extraSmall+small': {
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    lineHeight: '17px',
    right: 0,
    top: 0,
    borderRadius: 0
  },
  medium: {
    fontSize: 14,
    transform: `translateX(calc( -100% + ${DEFAULT_BUTTON_SIZE}px + ${TOOLTIP_BACKGROUND_PADDING.md}px))`
  },
  'large+extraLarge': {
    fontSize: 18,
    transform: `translateX(calc( -100% + ${DEFAULT_BUTTON_SIZE}px + ${TOOLTIP_BACKGROUND_PADDING.lg}px))`
  }
};
